export interface NavSubLink {
  label: string;
  href: string;
}

export interface NavLink {
  label: string;
  href: string;
  highlight?: boolean;
  submenu?: NavSubLink[];
}

export interface ShopCategory {
  name: string;
  path: string;
}

export interface NavConfig {
  shopCategories: ShopCategory[];
  navLinks: NavLink[];
}

// BBQ Navigation
export const bbqNavLinks: NavLink[] = [
  {
    label: "Outdoor Kitchens",
    href: "/outdoor-kitchens",
    submenu: [
      { label: "Custom Islands", href: "/outdoor-kitchens/custom-islands" },
      { label: "Modular Islands", href: "/outdoor-kitchens/modular-islands" },
      { label: "Built-In Islands", href: "/outdoor-kitchens/built-in-islands" },
      { label: "Lifetime Warranty", href: "/outdoor-kitchens/lifetime-warranty" },
      { label: "3D Design Wizard", href: "/design-wizard" },
      { label: "DFW Locations", href: "/outdoor-kitchens-dallas" },
    ],
  },
  {
    label: "Grills",
    href: "/grills",
    submenu: [
      { label: "Gas Grills", href: "/grills/gas-grills" },
      { label: "Charcoal Grills", href: "/grills/charcoal-grills" },
      { label: "Argentine Grills", href: "/grills/argentine-grills" },
      { label: "Built-In Grills", href: "/grills/built-in-grills" },
    ],
  },
  {
    label: "Smokers",
    href: "/smokers",
    submenu: [
      { label: "Pellet Smokers", href: "/smokers/pellet-smokers" },
      { label: "Offset Smokers", href: "/smokers/offset-smokers" },
      { label: "Vertical Smokers", href: "/smokers/vertical-smokers" },
      { label: "Kamado Smokers", href: "/smokers/kamado-smokers" },
    ],
  },
  {
    label: "Brands",
    href: "/outdoor-kitchen-brands",
    submenu: [
      { label: "All Brands", href: "/outdoor-kitchen-brands" },
      { label: "Blaze Grills", href: "/outdoor-kitchen/blaze-grills" },
      { label: "Big Green Egg", href: "/outdoor-kitchen/big-green-egg" },
      { label: "Traeger", href: "/outdoor-kitchen/traeger-grills" },
      { label: "Compare Brands", href: "/outdoor-kitchen/compare/blaze-vs-coyote" },
      { label: "Best For Guides", href: "/outdoor-kitchen/best/outdoor-kitchens" },
    ],
  },
  {
    label: "Pizza Ovens",
    href: "/pizza-ovens",
    submenu: [
      { label: "Karma Pizza Ovens", href: "/pizza-ovens/karma" },
      { label: "Wood Fired", href: "/pizza-ovens/wood-fired" },
      { label: "Gas Pizza Ovens", href: "/pizza-ovens/gas-pizza-ovens" },
      { label: "Hybrid Ovens", href: "/pizza-ovens/hybrid-ovens" },
      { label: "Pizza Oven Accessories", href: "/pizza-ovens/accessories" },
      { label: "Recipes & Tips", href: "/pizza-ovens/recipes" },
      { label: "Buying Guide", href: "/pizza-ovens/buying-guide" },
    ],
  },
  {
    label: "Refrigeration",
    href: "/refrigeration",
    submenu: [
      { label: "Outdoor Refrigerators", href: "/refrigeration/outdoor-refrigerators" },
      { label: "Ice Makers", href: "/refrigeration/ice-makers" },
      { label: "Beverage Centers", href: "/refrigeration/beverage-centers" },
    ],
  },
  { label: "Accessories", href: "/accessories" },
  { label: "Buying Guide", href: "/buying-guide" },
  { label: "Showroom", href: "/showroom" },
  { label: "Clearance", href: "/clearance", highlight: true },
];
